const AppEmbed = () => {
  return (
    <div className="min-h-screen pt-16 md:pt-20" data-testid="app-embed-page">
      <iframe
        src="https://seller-insights-hub-1.emergent.host"
        title="BrandBorn Seller Insights App"
        className="w-full border-0"
        style={{ height: 'calc(100vh - 4rem)' }}
        allow="clipboard-write; encrypted-media"
        loading="lazy"
      />
    </div>
  );
};

export default AppEmbed;
